import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import PageLoader from '@cox/core-ui8/dist/PageLoader'
import SwitchUser from './pages/SwitchUser'
import SwitchUserError from './pages/SwitchUserError'
import Link from './pages/link'
import Error from './pages/Error'

const AppRoutes = () => {
  const { appData } = useAppDataContext()
  console.log('🚀 ~ AppRoutes ~ appData:', appData)
  const prefix = (appData as any)?.prefix
  console.log('🚀 ~ AppRoutes ~ prefix:', prefix)
  const appContext = (appData as any)?.appName
  console.log('🚀 ~ AppRoutes ~ appContext:', appContext)

  if (Object.keys(appData).length > 0) {
    const basename = `${prefix}/${appContext}`

    // When served from a different app context (e.g. wafr3-example-app loading this bundle
    // for its error page), the current URL won't start with our basename and React Router
    // would refuse to render anything. Bypass the Router and render the Error page directly.
    if (!window.location.pathname.startsWith(basename)) {
      return <Error />
    }

    return (
      <Router basename={basename}>
        <Routes>
          <Route path='/release.txt' element={<RedirectToFile />} />
          <Route path='/csr/switchUser.html-v8' element={<SwitchUser />} />
          <Route path='/csr/switchUserError.html-v8' element={<SwitchUserError />} />
          <Route path='/get-link.html' element={<Link />} />
          <Route path='/error.html' element={<Error />} />
        </Routes>
      </Router>
    )
  }
  return <PageLoader />
}

function RedirectToFile() {
  useEffect(() => {
    window.location.href = '/release.txt'
  }, [])

  return null
}

export default AppRoutes
